<template>
  <div class="winnerPage">
    <img class="" src="@/assets/img/winner/img.png" width="100%">
  </div>
</template>

<script>
  export default {
    name: 'winnerPage',
    components: {
    },
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      
    }
  }
</script>
<style lang="scss">
  .winnerPage {

  }
</style>